import React, { useEffect } from 'react'
import { TextFieldSeeker } from "@ui-seeker/core"


export default function ModalSitesSelector({ applyFilters, filteredSites, onChangeSite }) {

	useEffect(() => {
		applyFilters()
	}, [filteredSites])

	return <TextFieldSeeker
		startIcon="magnifying-glass"
		label="Filter sites"
		placeholder="All sites"
		value={filteredSites}
		onChange={onChangeSite}
	/>
}